const ShimmerMain = () => (
  <div className="relative w-full h-[60vh] md:h-[90vh] bg-shimmer rounded-lg overflow-hidden">
    <div className="absolute top-0 left-0 w-full h-full bg-shimmer-wave z-10"></div>
  </div>
);

export default ShimmerMain;
